import React from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import {Link, graphql} from 'gatsby'
import aboutOne from "../images/about_services01.png"
import aboutTwo from "../images//about_services02.png"
import aboutThree from "../images//about_services03.png"
import aboutFour from "../images//about_services04.png"


const Wrapper = styled.div`
    margin: 3rem 1rem 1rem 1rem;
    padding: 1rem ${props => props.theme.spacer.horizontal};
    color: ${props => props.theme.colors.grey};
    margin: 0 auto;
    padding: 18rem 2rem 0;
    max-width: 55rem;
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        padding: 10rem 2rem 0;
    }
    a {
        text-decoration: none;
        color: ${props => props.theme.brand.primary};
    }
    p {font-family: "Roboto",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}
    h4 {
        font-family: "Roboto",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        font-size: 1.15rem;
        color: ${props => props.theme.colors.black};
        font-weight: normal;
        text-decoration: underline;
        margin: 0;
    }
    .services__item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        padding: 0 0 5rem;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-align: start;
            -ms-flex-align: start;
            align-items: flex-start;
        }
    }
    .services__item--reversed {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
            -ms-flex-direction: row-reverse;
                flex-direction: row-reverse;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
                -ms-flex-direction: column;
                    flex-direction: column;
        }
    }
    .services__item--pad-1 {
        padding-left: 5rem;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            padding-left: 0rem;
        }
    }
    .services__item--pad-2 {
        padding-right: 7.5rem;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            padding-right: 0;
        }
    }
    .services__item--img {
        max-width: 15rem;
        margin: 0 3rem;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            margin: 0;
        }
    }
    .services__item--img--first {
        margin: 0 3rem 0 0;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
           margin: 0;
        }
    }
    .page-desc {
        color: #222;
        font-family: 'Roboto Slab', Georgia, serif;
        font-size: 2rem;
        line-height: 60px;
        font-weight: 300;
        margin-top: 1rem;
        margin-bottom: 3rem;
        text-align: left;
    }
`

const Intro = () => (
    <Wrapper data-testid="intro">
        <div className="services">
            <p class="page-desc">Make a memorable experience. Let your project act in a way that will exceeds users' expectations. See what i can do to help you. </p>
                <div className="services__item">
                    <div className="">
                        <img className="services__item--img  services__item--img--first" src={aboutOne} alt="UI & UX Design" />
                    </div>
                    <div className="">
                        <h4>UI & UX Design</h4>
                        <p>If you imagine a product as the human body, the bones represent the code which give it structure. The organs represent the UX design: measuring and optimizing against input for supporting life functions. And UI design represents
                            the cosmetics of the body–its presentation, its senses and reactions. </p>
                    </div>
                    <div className="clear"></div>
                </div>

                <div className="services__item services__item--pad-1">
                    <div className="">
                            <img className="services__item--img" src={aboutTwo} alt="UI & UX Development" />
                    </div>
                    <div className="">
                        <h4>UI & UX Development</h4>
                        <p>The process of enhancing customer satisfaction and loyalty by improving the usability, ease of use, and pleasure provided in the interaction between the customer and the digital product. In short meaning the code behind what we
                            see on a device, or how we use a app.</p>
                    </div>
                    <div className="clear"></div>
                </div>

                <div className="services__item services__item--reversed services__item--pad-2">
                    <div className="">
                        <img className="services__item--img" src={aboutThree} alt="Digital Design" />
                    </div>
                    <div className="">
                        <h4>Digital Design</h4>
                        <p>The work on website design, mobile apps, and other online content for a range of industries and creating landing pages, develop email marketing collateral, banners and other online marketing materials, and importantly, also work
                            in languages such as HTML5, CSS3 & JavaScript</p>
                    </div>
                    <div className="clear"></div>
                </div>

                <div className="services__item services__item--pad-1">
                    <div className="">
                            <img className="services__item--img" src={aboutFour} alt="Front End Development" />
                    </div>
                    <div className="">
                        <h4>Front-end Development</h4>
                        <p>A mix of programming and layout that powers the visuals and interactions of the web. If a website were a house, front-end web development would be the pretty exterior that gives the house character, or the host that invites guests
                            in and makes them feel at home.</p>
                    </div>
                    <div className="clear"></div>
                </div>
        </div>
     </Wrapper>
)

export default Intro

export const fluidImage = graphql`
fragment fluidImage on File {
  childImageSharp {
    fluid(maxWidth: 1000) {
      ...GatsbyImageSharpFluid
    }
  }
}
`;

export const pageQuery = graphql`
  query {
    imageOne: file(relativePath: { eq: "about_services01.png" }) {
        ...fluidImage
    }
    imageTwo: file(relativePath: { eq: "about_services02.png" }) {
       ...fluidImage
    }
    imageThree: file(relativePath: { eq: "about_services03.png" }) {
        ...fluidImage
    }
    imageFour: file(relativePath: { eq: "about_services04.png" }) {
        ...fluidImage
    }
    imageLogo: file(relativePath: { eq: "Portfolio-Silviu-Stefanescu-logo-NEW.png" }) {
        ...fluidImage
    }
  }
  `
